import { FC, useEffect } from 'react';
import scrollTopIcon from 'assets/icons/scroll-top-light.svg';
import { clsx } from 'clsx';
import { useSchedule } from 'features/index';
import { useAppSelector } from 'shared/lib';

import { useScroll } from '../hooks';
import { MakeRows } from '../lib';
import { SkeletonTimelineSchedule } from '../skeletonTimelineSchedule';

import styles from './styles.module.scss';

export const StageTimelineSchedule: FC = () => {
  const { startIntervalDate, isGroupSchedule, endIntervalDate } =
    useAppSelector((state) => state.schedulePublicReducer);

  const { groupSchedule, isSkeleton, teacherSchedule, filterSchedule } =
    useSchedule();

  const {
    containerScheduleRef,
    isDragging,
    isScrollToTopVisible,
    isScrolled,
    handleScroll,
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
    scrollToTop,
  } = useScroll();

  useEffect(() => {
    filterSchedule(startIntervalDate, endIntervalDate);
  }, [startIntervalDate, endIntervalDate]);

  return (
    <div
      className={clsx(styles['container-timeline-schedule'], {
        [styles['container-timeline-schedule_scrolled']]: isScrolled,
      })}
      style={{ cursor: isDragging ? 'grabbing' : 'default' }}
      ref={containerScheduleRef}
      onScroll={handleScroll}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      {isSkeleton ? (
        <SkeletonTimelineSchedule />
      ) : (
        MakeRows(
          isGroupSchedule ? groupSchedule : teacherSchedule,
          startIntervalDate,
          endIntervalDate,
        )
      )}

      {isScrollToTopVisible && (
        <button className={styles['scroll-top-button']} onClick={scrollToTop}>
          <img
            className={styles['scroll-top-button__icon']}
            src={scrollTopIcon}
          />
        </button>
      )}
    </div>
  );
};
